import React from 'react';
import './ReportReasonsModal.css';

interface ReportReasonsModalProps {
  productTitle: string;
  reasons: string[];
  onClose: () => void;
  onDecline?: () => void;
}

const ReportReasonsModal: React.FC<ReportReasonsModalProps> = ({
  productTitle,
  reasons,
  onClose,
  onDecline,
}) => {
  return (
    <div className="report-reasons-modal-overlay" onClick={onClose}>
      <div className="report-reasons-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="report-reasons-modal-header">
          <h3 className="report-reasons-modal-title">Motive de raportare</h3>
          <button className="report-reasons-modal-close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="#071105" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        
        <div className="report-reasons-product-title">
          <strong>Produs:</strong> {productTitle}
        </div>

        <div className="report-reasons-list">
          <p className="report-reasons-label">Motivele pentru care acest produs a fost raportat:</p>
          <ul className="report-reasons-items">
            {reasons.map((reason, index) => (
              <li key={index} className="report-reason-item">
                {reason}
              </li>
            ))}
          </ul>
        </div>

        <div className="report-reasons-modal-actions">
          <button className="report-reasons-btn-close" onClick={onClose}>
            Închide
          </button>
          {onDecline && (
            <button className="report-reasons-btn-decline" onClick={onDecline}>
              Respinge Produs
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportReasonsModal;
